import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=7fa96b4e&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa96b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa96b4e')) {
      api.createRecord('7fa96b4e', component.options)
    } else {
      api.reload('7fa96b4e', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=7fa96b4e&scoped=true&", function () {
      api.rerender('7fa96b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/table/item_actions/Show.vue"
export default component.exports